/*
 * Copyright (C) 2021 IHS Markit.
 * All Rights Reserved
 *
 * NOTICE: All information contained herein is, and remains
 * the property of IHS Markit and its suppliers,
 * if any. The intellectual and technical concepts contained
 * herein are proprietary to IHS Markit and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from IHS Markit.
 */
export enum SubSectorEnum{
  Empty = '(unassigned)',
  Banks	=	'Banks',
  Basic_Materials	=	'Basic Materials',
  Consumer_Goods	=	'Consumer Goods',
  Consumer_Services	=	'Consumer Services',
  Core_Financials	=	'Core Financials',
  Financial_Services	=	'Financial Services',
  Financials	=	'Financials',
  Non_Financials	=	'Non-Financials',
  Health_Care	=	'Health Care',
  Industrials	=	'Industrials',
  Oil_Gas	=	'Oil & Gas',
  Real_Estate	=	'Real Estate',
  Technology	=	'Technology',
  Telecommunications	=	'Telecommunications',
  Utilities	=	'Utilities',
  Covered	=	'Covered',
}
